/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import IErrorHandler from "./IErrorHandler";

class ErrorEntry
{
    public NumOccurances: number = 0;
    public History: number[] = [];
}

interface IErrorMap
{
    [error: string]: ErrorEntry;
}

export default class SentryErrorHandler implements IErrorHandler
{
    private _raven: any = null;

    private _errorHistory: IErrorMap = {};
    private _maxInstances: number = 5;
    private _windowDuration: number = 360000.0;

    public constructor()
    {
        // tslint:disable:no-string-literal
        this._raven = window["raven"];
        window.onerror = this.handleUnhandled.bind(this);
    }

    public DropBreadcrumb(category: string, message?: string, data?: any): void {
        let breadcrumb: any = {};

        if (category && category.length !== 0) { breadcrumb.category = category; }
        if (message && message.length !== 0) { breadcrumb.message = message; }
        if (data) { breadcrumb.data = data; }

        breadcrumb.level = "info";

        this._raven.captureBreadcrumb(breadcrumb);
    }
    public LogError(message: string): void
    {
        this.handleError(message);
    }

    private handleError(message: string): void
    {
        if (this._errorHistory[message] == null)
        {
            this._errorHistory[message] = new ErrorEntry();
        }

        if (this._errorHistory[message].History.length < this._maxInstances)
        {
            this._errorHistory[message].History.push(Date.now());
            this.passOnError(message);
        }
        else
        {
            let oldestErrorTime: number = this._errorHistory[message].History[0];
            let elapsedTime: number = Date.now() - oldestErrorTime;
            if (elapsedTime > this._windowDuration)
            {
                this._errorHistory[message].History.shift();
                this._errorHistory[message].History.push(Date.now());
                this.passOnError(`Ignored [${this._errorHistory[message].NumOccurances}]${message}`);
                this._errorHistory[message].NumOccurances = 0;
            }
            else
            {
                this._errorHistory[message].NumOccurances++;
            }
        }
    }

    private passOnError(message: string): void
    {
        if (this._raven == null)
        {
            this._raven = window["raven"];
        }
        try
        {
            throw new Error(message);
        }
        catch (e)
        {
            this._raven.captureException(e);
        }
    }

    private handleUnhandled(message, source, lineno, colno, error): void
    {
        this.handleError(message);
    }
}
